<div class="row policy-list main">
  <!-- The data has not come back yet -->
  @if (dataLoading | async) {
    <ds-localized-spinner
      class="block pad-bottom-20"
      [dataLoading]="dataLoading"
      [loadingMessage]="'Looking for Policies...'"
    >
    </ds-localized-spinner>
  }
  <alerts-bar [alertSelector]="'getHomesitePoliciesAlert'"></alerts-bar>
  @if (policySummaries$ | async; as policySummaries) {
    @if (!(dataLoading | async) && (hasPolicies || policySummaries?.length > 0)) {
      <div>
        <!-- <p *dsPartnerAFI>
        <strong dsContent [contentPath]="'policy.note'"></strong>
        <span dsContent [contentPath]="'policy.unavailablePoliciesNote'"></span>
        <span dsPartnerContent [brandContent]="'selectPrettyCusCareNumber'"></span>.
      </p> -->
        <div class="pad-top-30">
          @if (hasPolicies || policySummaries?.length) {
            <ds-accordion [allowMultipleOpenCategories]="true" [allowToggleAccordion]="true">
              @if (autoPolicies?.length) {
                <ds-accordion-category
                  title="Vehicle ({{ autoPolicies | riskcount }})"
                  icon="auto"
                  [isOpen]="true"
                >
                  <app-policy-summary
                    [policies]="autoPolicies"
                    [advancedAutoPolicies]="advancedAutoPolicies$ | async"
                    [hasCompAndCollisonCoverage]="hasCompAndCollisonCoverage$ | async"
                    [type]="'auto'"
                    [summary]="componentData.autoSummaryText"
                    url="/policies/auto"
                    data-cy="autoSummaryText"
                    [isPolicyCancelled]="isAutoPolicyCancelled"
                  >
                  </app-policy-summary>
                </ds-accordion-category>
              } @else {
                <amfam-no-detail-summary
                  title="Vehicle"
                  icon="auto"
                  [summaries]="policySummaries$ | async | filterpolicy: vehicleTypeConstants.AUTO"
                  (detailButtonClicked)="openPolicyUnavailableModal()"
                ></amfam-no-detail-summary>
              }
              @if (propertyPolicies?.length) {
                <ds-accordion-category
                  title="Home ({{ propertyPolicies | riskcount }})"
                  icon="home"
                  [isOpen]="true"
                >
                  <app-policy-summary
                    [policies]="propertyPolicies"
                    [type]="'home'"
                    [summary]="componentData.propertySummaryText"
                    url="/policies/property"
                    data-cy="propertySummaryText"
                    [isPolicyCancelled]="isPropertyPolicyCancelled"
                  >
                  </app-policy-summary>
                </ds-accordion-category>
              } @else {
                <amfam-no-detail-summary
                  title="Home"
                  [summaries]="policySummaries$ | async | filterpolicy: genericProductType.Home"
                  icon="home"
                  (detailButtonClicked)="openPolicyUnavailableModal()"
                ></amfam-no-detail-summary>
              }
              @if (umbrellaPolicies?.length) {
                <ds-accordion-category
                  title="Umbrella ({{ umbrellaPolicies | riskcount }})"
                  icon="umbrella"
                  [isOpen]="true"
                >
                  <app-policy-summary
                    [policies]="umbrellaPolicies"
                    [type]="'umbrella'"
                    [summary]="componentData.umbrellaSummaryText"
                    url="/policies/umbrella"
                    data-cy="umbrellaSummaryText"
                    [isPolicyCancelled]="isUmbrellaPolicyCancelled"
                  >
                  </app-policy-summary>
                </ds-accordion-category>
              } @else {
                <amfam-no-detail-summary
                  title="Umbrella"
                  icon="umbrella"
                  [summaries]="policySummaries$ | async | filterpolicy: genericProductType.Umbrella"
                  (detailButtonClicked)="openPolicyUnavailableModal()"
                ></amfam-no-detail-summary>
              }
              @if (lifePolicies?.length) {
                <ds-accordion-category
                  title="Life ({{ lifePolicies | riskcount }})</b>"
                  icon="life"
                  [isOpen]="true"
                >
                  <app-policy-summary
                    [policies]="lifePolicies"
                    [type]="'life'"
                    [summary]="componentData.lifeSummaryText"
                    url="/policies/life"
                  >
                  </app-policy-summary>
                </ds-accordion-category>
              } @else {
                <amfam-no-detail-summary
                  title="Life"
                  icon="life"
                  [isLife]="true"
                  [summaries]="policySummaries$ | async | filterpolicy: genericProductType.Life"
                  (detailButtonClicked)="openPolicyUnavailableModal()"
                ></amfam-no-detail-summary>
              }
              @if (cyclePolicies?.length) {
                <ds-accordion-category
                  title="Cycle ({{ cyclePolicies | riskcount }})"
                  icon="motorcycle"
                  [isOpen]="true"
                >
                  <app-policy-summary
                    [policies]="cyclePolicies"
                    [type]="'auto'"
                    [isSpecialtyLine]="true"
                    [summary]="componentData.cycleSummaryText"
                    url="/policies/auto"
                  >
                  </app-policy-summary>
                </ds-accordion-category>
              } @else {
                <amfam-no-detail-summary
                  title="Cycle"
                  icon="motorcycle"
                  [summaries]="policySummaries$ | async | filterpolicy: vehicleTypeConstants.CYCLE"
                  (detailButtonClicked)="openPolicyUnavailableModal()"
                ></amfam-no-detail-summary>
              }
              @if (watercraftPolicies?.length) {
                <ds-accordion-category
                  title="Watercraft ({{ watercraftPolicies | riskcount }})"
                  icon="boat"
                  [isOpen]="true"
                >
                  <app-policy-summary
                    [policies]="watercraftPolicies"
                    [type]="'auto'"
                    [isSpecialtyLine]="true"
                    [summary]="componentData.WatercraftSummaryText"
                    url="/policies/auto"
                  >
                  </app-policy-summary>
                </ds-accordion-category>
              }
              <ng-template #watercraftSummaries>
                <amfam-no-detail-summary
                  icon="boat"
                  tile="Watercraft"
                  [summaries]="
                    policySummaries$ | async | filterpolicy: vehicleTypeConstants.WATERCRAFT
                  "
                  (detailButtonClicked)="openPolicyUnavailableModal()"
                ></amfam-no-detail-summary>
              </ng-template>
              @if (rvPolicies?.length) {
                <ds-accordion-category
                  title="Recreational Vehicle ({{ rvPolicies | riskcount }})"
                  icon="rv"
                  [isOpen]="true"
                >
                  <app-policy-summary
                    [policies]="rvPolicies"
                    [type]="'auto'"
                    [isSpecialtyLine]="true"
                    [summary]="componentData.RecreationalVehicleSummaryText"
                    url="/policies/auto"
                  >
                  </app-policy-summary>
                </ds-accordion-category>
              }
              <ng-template #rvSummaries>
                <amfam-no-detail-summary
                  title="Recreational Vehicle"
                  icon="rv"
                  [summaries]="policySummaries$ | async | filterpolicy: vehicleTypeConstants.RV"
                  (detailButtonClicked)="openPolicyUnavailableModal()"
                ></amfam-no-detail-summary>
              </ng-template>
              @if (hasPolicies && !(policyCount === 1 && lifePolicies.length === 1)) {
                <ds-accordion-category
                  title="Programs/Discounts"
                  icon="discounts"
                  data-cy="policyListDiscountsAccordion"
                >
                  @if (isEligibleForPaperless) {
                    <div>
                      <h4
                        class="heading-sub-section pad-bottom-20 margin-left-20"
                        dsContent
                        [contentPath]="'policy.paperlessPolicyTitle'"
                        data-cy="policyPaperlessTitle"
                      ></h4>
                      @if (isEnrolled) {
                        <p class="margin-left-20 margin-right-20">
                          <span
                            dsContent
                            [contentPath]="'policy.madeGreatChoiceText'"
                            data-cy="policyMadeGreatChoiceText"
                          ></span>
                          <a dsRouterLink="/faq/go-paperless"
                            ><span
                              dsContent
                              [contentPath]="'policy.faqPaperLess'"
                              data-cy="policyFaqPaperLess"
                            ></span
                          ></a>
                          <span
                            dsContent
                            [contentPath]="'policy.viewText'"
                            data-cy="policyViewText"
                          ></span>
                          <a dsRouterLink="/terms/go-paperless"
                            ><span
                              dsContent
                              [contentPath]="'policy.TAndC'"
                              data-cy="policyTAndC"
                            ></span></a
                          >.
                        </p>
                      }
                      @if (!isEnrolled) {
                        <p class="margin-left-20 margin-right-20">
                          <span
                            dsContent
                            [contentPath]="'policy.getAccessText'"
                            data-cy="policyGetAccessText"
                          ></span>
                          @if (hasAdvancePolicies) {
                            <span
                              dsContent
                              [contentPath]="'policy.discountText'"
                              data-cy="policyDiscountText"
                            ></span>
                          }
                          <span dsContent [contentPath]="'policy.returnAnyTimeMessage'"></span>
                        </p>
                      }
                      <div class="sub-list"><app-go-paperless-promo></app-go-paperless-promo></div>
                    </div>
                  }
                  <div class="sub-list"><app-kyd-smartphone-promo></app-kyd-smartphone-promo></div>
                </ds-accordion-category>
              }
            </ds-accordion>
          }
        </div>
      </div>
    }
  }

  @if (
    (summariesError$ | async) ||
    ((summariesLoaded$ | async) && (policySummaries$ | async)?.length === 0)
  ) {
    <div>
      <p class="pad-bottom-10">
        <span dsContent [contentPath]="'policy.noPoliciesToDisplay.tileHeading'"> </span>
        <span *dsPartnerConnect bound-content [bindTo]="componentData.policyListTextPartner"></span>
      </p>
      <p>
        <span dsContent [contentPath]="'policy.noPoliciesToDisplay.tileData'"> </span>
      </p>
    </div>
  }
</div>

<ds-modal [id]="policyUnavailableModalId" [closeOthers]="true" maxWidth="300">
  <div class="policy-modal">
    <h3 class="policy-modal__heading">Details Unavailable</h3>
    <div class="policy-modal__content">
      The details of this policy are currently unavailable. Please try again later.
    </div>
    <button
      ds-button
      class="policy-modal__action"
      (click)="closePolicyUnavailableModal()"
      data-cy="policyUnavailableModal"
    >
      OK
    </button>
  </div>
</ds-modal>
